import { DICT_DEFAULT_RESOURCE_TEXT } from "../utils/constants";
import { isDefinedAndNotNull } from "../utils/dom";
import { ValidationService } from "../services/validation.service";
import SectionComponent from "./section.component";

export default class ValidationErrorComponent extends SectionComponent {
    
    #resourcesService;

    constructor() {
        super();
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
        this.validationSvc = new ValidationService();
    }

    validateForm(formData, customerInfoStructure) {
        this.clear();
        let isValidFieldValue = true;
        let isValidFormData = true;
        
        if (isDefinedAndNotNull(customerInfoStructure)) {
            for (let formStuctureIndex = 0; formStuctureIndex < customerInfoStructure.length; formStuctureIndex++) {
                if (this.validationSvc.isRequiredField(customerInfoStructure[formStuctureIndex])) {
                    isValidFieldValue = this.validationSvc.validateRequiredField(formData[formStuctureIndex]);
                }
                const fieldNameTranslation = this.#resourcesService.getFormattedResource(customerInfoStructure[formStuctureIndex].name, 'SELFSCHEDULER_FORM', 'LABEL', customerInfoStructure[formStuctureIndex].name);
                if (!isValidFieldValue) {
                    this.addValidationError(formData[formStuctureIndex], this.#resourcesService.getResource("REQUIRED_VALIDATION_ERROR", DICT_DEFAULT_RESOURCE_TEXT.REQUIRED_VALIDATION_ERROR), fieldNameTranslation);
                    isValidFormData = false;
                } else {
                    const [isValid, validationMessage] = this.validationSvc.validateRegularExpressions(customerInfoStructure[formStuctureIndex], formData[formStuctureIndex].value, this.#resourcesService);
                    if (isValid) {
                        let parentElement = formData[formStuctureIndex].parentElement;
                        this.removeValidationError(parentElement, formData[formStuctureIndex]);
                    } else {
                        this.addValidationError(formData[formStuctureIndex], validationMessage, fieldNameTranslation);
                        isValidFormData = false;
                    }
                }
                isValidFieldValue = true;
            }
        }
        return isValidFormData;
    }

    removeValidationCheckMark(parentElement) {
        if (isDefinedAndNotNull(parentElement)) {
            const checkMarkList = parentElement.getElementsByClassName("v24-scheduler-checkmark");
            if (checkMarkList.length > 0) {
                checkMarkList[0].classList.remove("v24-scheduler-checkmark-error");
            }
        }
    }

    addValidationError(formElement, validationMessage, fieldName) {
        this.classList.add("v24-scheduler-error-section");
        if (isDefinedAndNotNull(formElement)) {
            formElement.classList.add("v24-scheduler-warning-border");
            if (isDefinedAndNotNull(validationMessage) && validationMessage != '') {
                validationMessage = validationMessage.replace("{0}", fieldName);
                let fieldError = document.createElement("span");
                fieldError.innerHTML = validationMessage;
                this.appendChild(fieldError);
            }
        }
    }

    removeValidationError(parentElement, formElement) {
        if (isDefinedAndNotNull(formElement) && isDefinedAndNotNull(parentElement)) {
            formElement.classList.remove("v24-scheduler-warning-border");
            this.removeValidationCheckMark(parentElement);
        }
    }

    clear() {
        this.classList.remove("v24-scheduler-error-section");
        this.setContent("");
    }
}